module.exports = __webpack_public_path__ + "static/media/tiempo.f6e7cd86.svg";